import { computed } from 'vue';
import router from '@/router';
import { routeNames, pathNames } from '@/constants/routes/acvRoute';

export default function useAcvRoute() {
  const currentRouteName = computed(() => router.currentRoute?.value?.name);
  const validateRouteName = (name) => typeof currentRouteName.value === 'string' && currentRouteName.value === routeNames.get(name);
  const currentRoutePath = computed(() => router.currentRoute?.value?.path);
  const validateRoutePath = (path) => typeof currentRoutePath.value === 'string' && currentRoutePath.value.includes(pathNames.get(path));

  const isOnAuction = computed(() => validateRouteName('auction'));

  const isOnAuctionAccessRegistration = computed(() => validateRoutePath('auctionAccessRegistration'));

  const isOnBuyingActive = computed(() => validateRouteName('buyingActive'));

  const isOnBuyingRunList = computed(() => validateRouteName('buyingRunList'));

  const isOnForgot = computed(() => validateRouteName('forgot') || validateRoutePath('forgot') || validateRoutePath('password'));

  const isOnLogin = computed(() => validateRouteName('login') || validateRoutePath('login'));

  const isOnLogout = computed(() => validateRouteName('logout') || validateRoutePath('logout'));

  const isOnMarketplace = computed(() => validateRouteName('marketplace'));

  const isOnMyAcv = computed(() => validateRoutePath('myAcv') || validateRouteName('myAcv'));

  const isOnMyAcvActive = computed(() => validateRouteName('myAcvActive'));

  const isOnMyAcvActiveSelling = computed(() => validateRouteName('myAcvActiveSelling'));

  const isOnMyAcvMyInventory = computed(() => validateRouteName('myAcvMyInventory'));

  const isOnMyAcvSaved = computed(() => validateRouteName('myAcvSaved'));

  const isOnMyAcvSold = computed(() => validateRouteName('myAcvSold'));

  const isOnNotifications = computed(() => validateRouteName('notifications'));

  const isOnRegistrationEmailVerification = computed(() => validateRouteName('registrationEmailVerification_v2'));

  const isSavedAuction = computed(() => validateRouteName('saved'));

  return {
    currentRouteName,
    currentRoutePath,
    isOnAuction,
    isOnAuctionAccessRegistration,
    isOnBuyingActive,
    isOnBuyingRunList,
    isOnForgot,
    isOnLogin,
    isOnLogout,
    isOnMarketplace,
    isOnMyAcv,
    isOnMyAcvActive,
    isOnMyAcvActiveSelling,
    isOnMyAcvMyInventory,
    isOnMyAcvSaved,
    isOnMyAcvSold,
    isOnNotifications,
    isOnRegistrationEmailVerification,
    isSavedAuction,
    validateRouteName,
    validateRoutePath,
  };
}
